import i18n from 'i18next';

export const getVaultTourSteps = () => [
  {
    target: '[data-tour="vault_navbar"]',
    title: i18n.t('tutorial:vault_navbar_title'),
    content: i18n.t('tutorial:vault_navbar_content'),
    disableBeacon: true,
    containerClassName: 't-max-w-80',
    placement: 'right-start',
    currentStep: 1,
    totalSteps: 4,
  },
  {
    target: '[data-tour="vault_recommendation"]',
    title: i18n.t('tutorial:vault_recommendation_title'),
    content: i18n.t('tutorial:vault_recommendation_content'),
    disableBeacon: true,
    containerClassName: 't-max-w-80',
    placement: 'left-start',
    currentStep: 2,
    totalSteps: 4,
  },
  {
    target: '[data-tour="vault_assets"]',
    title: i18n.t('tutorial:vault_assets_title'),
    content: i18n.t('tutorial:vault_assets_content'),
    disableBeacon: true,
    containerClassName: 't-max-w-80',
    placement: 'auto',
    currentStep: 3,
    totalSteps: 4,
  },
  {
    target: '[data-tour="vault_markAsCompleted"]',
    title: i18n.t('tutorial:vault_markAsCompleted_title'),
    content: i18n.t('tutorial:vault_markAsCompleted_content'),
    disableBeacon: true,
    containerClassName: 't-max-w-80',
    placement: 'auto',
    currentStep: 4,
    totalSteps: 4,
  },
];
